exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_scroll[data-v-6778d11a] {\n  overflow-x: scroll !important;\n}\n.table_width[data-v-6778d11a] {\n  width: 1000px;\n}", ""]);

// exports
